<div style="width: 100%; height: 100%;padding: 2% 5%;">
<div style="width: 100%; height: 90%;">
    <img [src]="path" alt="Banner Image" class="banner-image" />
</div>
<div style="text-align: center;">
    <button mat-raised-button color="primary" class="button"(click)="dialogRef.close()" translate>Cancel</button>
</div>
</div>

